'use strict';

import {Component,Inject, Input,Output, EventEmitter} from 'ng-metadata/core';
import {ConfigurationUtil} from '../../../../../../nddUtils/configurationUtil.service';


import { LocationService } from './location.service';


@Component({
'selector': 'prm-location',
templateUrl: 'components/search/fullView/getit/opac/locations/location/location.html',
})



export class PrmLocation{
	@Input() private location;
    @Output() private clickEvent= new EventEmitter<void>();

    constructor(private locationService: LocationService,
				@Inject('opacLocations') public opacLocations,
				@Inject('$window') private $window: ng.IWindowService,
                private configurationUtil: ConfigurationUtil) {

    }

	public onClick(){
		this.isOvp() ? this.clickEvent.emit(null) :
			this.$window.open(this.location.holdingURL, '_blank');
	}


	public isOvp(){
		return this.locationService.isOvpLocation(this.location);
	}

	public getButtonActionLabel(){
		return this.isOvp() ? 'nui.aria.locations.expand' : 'nui.aria.account.links.open';
	}
    
    isSuprima(){
        return (this.configurationUtil.getBackendSystem() === 'suprima');
    }

	private getLibraryName(location){
		return this.locationService.getLibraryName(location);

	}


	private getSubLibraryName(location){
		return this.locationService.getSubLibraryName(location);

	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locations/location/location.directive.ts